import React from "react";
import PropTypes from "prop-types";
import Badge from "antd/es/badge";
import Card from "antd/es/card";
import Col from "antd/es/col";
import Row from "antd/es/row";
import Divider from "antd/es/divider";

const CustomQuestions = ({ questions_ans }) => (
  <Card style={{ marginTop: "20px", borderColor: "#ffb551" }}>
    <Row type="flex" justify="space-between">
      <Col style={{ paddingTop: "5px" }}>
        <Badge count={"Custom Questions"} className="details-badge" />
      </Col>
    </Row>
    {questions_ans?.length > 0 &&
      questions_ans.map((qa, index) => (
        <div key={String(index)} className="left-margin">
          <Row>
            <Col span={24}>
              <span className="details-label">{qa.question}</span>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <span className="details-value">{qa.answer || "-"}</span>
            </Col>
          </Row>
          {questions_ans.length - 1 !== index ? <Divider /> : null}
        </div>
      ))}
  </Card>
);

CustomQuestions.propTypes = {
  questions_ans: PropTypes.object.isRequired,
};

export default CustomQuestions;
